import { CommonModule } from '@angular/common';
import { Component, Inject, NgModule, OnInit } from '@angular/core';
import {
  FormsModule,
  ReactiveFormsModule,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { User } from '@core/domain-classes/user';
import { TranslateModule } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { SecurityService } from '@core/security/security.service';
import { TranslationService } from '@core/services/translation.service';
import { BaseComponent } from 'src/app/base.component';
import { CommonError } from '@core/error-handler/common-error';
import { Router } from '@angular/router';

@Component({
  selector: 'app-validate-user',
  templateUrl: './validate-user.component.html',
  styleUrls: ['./validate-user.component.scss'],
})
export class ValidateUserComponent extends BaseComponent implements OnInit {
  validateUserForm: UntypedFormGroup;
  isLoading = false;
  userData: User;
  resultMessage: string;
  fieldTextType: boolean = false;
  lat: number;
  lng: number;
  logoImage: string;
  constructor(
    private fb: UntypedFormBuilder,
    private securityService: SecurityService,
    public translationService: TranslationService,
    private toastr: ToastrService,
    private router: Router
  ) {
    super(translationService);
  }

  ngOnInit(): void {
    this.createValidateUserForm();
    navigator.geolocation.getCurrentPosition((position) => {
      this.lat = position.coords.latitude;
      this.lng = position.coords.longitude;
    });
  }

  createValidateUserForm() {
    this.validateUserForm = this.fb.group({
      userName: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(6)]],
    });
  }

  checkUserValidate() {
    if (this.validateUserForm.valid) {
      this.isLoading = true;
      const userObject = Object.assign(this.validateUserForm.value, {
        latitude: this.lat,
        longitude: this.lng,
      });
      this.sub$.sink = this.securityService.validateUser(userObject).subscribe(
        (c: any) => {
          if (c?.isUserValid == null || c.isUserValid === '') {
            var email = this.validateUserForm.get('userName').value;
            this.router.navigate(['/generate-new-password'], {
              queryParams: { email: email },
            });
          } else {
            this.toastr.error(c?.isUserValid);
          }
          this.isLoading = false;
        },
        (err: CommonError) => {
          this.isLoading = false;
          if (err.messages) {
            err.messages.forEach((msg) => {
              this.toastr.error(msg);
            });
          } else if (err.error) {
            this.toastr.error(err.error as string);
          }
        }
      );
    }
  }
}

@NgModule({
  declarations: [ValidateUserComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule,
    MatChipsModule,
    MatProgressSpinnerModule,
    TranslateModule,
  ],
})
export class ValidateUserModule {}
